require('../jquery-ui-autocomplete.min.js');

var selectedElement = null;

function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

export const searchScripts = () => {

    var searchInputAutoCompMinLen = 3;

    //close the modal when clicked on X
    $('.search__clear').click((e) => {
        $('#site-header-search').modal('toggle');
    });

    /* when search suggestions are listed... */
    $("input.search__input").on("autocompleteopen", function (event, ui) {
        $(this).addClass('remove-bottom-left-border-radius');
    });

    $("input.search__input").on("autocompleteclose", function (event, ui) {
        $(this).removeClass('remove-bottom-left-border-radius');
    });

    //changing the input value based on focus
    $("input.search__input").on("autocompletefocus", function (event, ui) {
        event.preventDefault();
        //$(this).val(ui.item.label);
        selectedElement = ui.item;
        return false;
    });

    $('.search-results__submit').click(function () {
        var searchString = $('.search-results__input').val();
        if (searchString) {
            window.location.href = window["sharedData"].SearchFormatString.replace("{0}", encodeURIComponent(searchString));
        }
        return false;
    });

    //changing the input value based on Selection
    $("input.search__input").on("autocompleteselect", function (event, ui) {
        //event.preventDefault();
        return ui.item.label;
    });

    /* Navigates to the search page once you press enter on the search bar. */
    $(".search__input").keyup(function (e) {
        if (e.which == 13) {
            if(selectedElement != null) {
                window.location.href = selectedElement.url;
            } else {
            window.location.href = window["sharedData"].SearchFormatString.replace("{0}", encodeURIComponent(e.currentTarget.value)) + "&redirect=1";
            }
        } else if (![38, 40].includes(e.which)) {
            selectedElement = null;
        }
        $(e.currentTarget).val().length < searchInputAutoCompMinLen ? $(".auto-comp-list").empty() : false;
        $(e.currentTarget).removeClass('search__input-top-curved');
    })

    /* Navigates to the search page once you click the submit button. */
    $(".search__submit > div").click( (e) => {
        let search_text = $('.search__input').val();
        if (search_text.length > 0) {
            window.location.href = window["sharedData"].SearchFormatString.replace("{0}", encodeURIComponent(search_text)) + "&redirect=1";
        }
    })

    // method to get all details related to all funds
    async function getAllFundDetails() {
        let allData = { 'filterJson': '{"InvType":"all","AssetClass":[],"Funds":[],"ShareClass":[],"TableType":"search","CurrentPageId":"5517"}' }
        let url = "/Main/FundListingUs/GetFundData";
        let allFunds = null;

        const data = await $.post(url, allData);

        allFunds = data.Result.FundSet;

        return allFunds;
    }

    /* load search autocomplete source on search icon click */
    $('[data-target="#site-header-search"]').ready(async function (e) {
      const autoComplete = $("#autocomplete");
          if (autoComplete.length) autoComplete.autocomplete(
            {
                source: function (request, response) {
                    $.ajax(
                        {
                            url: "/common/SearchUsPage/GetBestBets/?searchText="
                                + encodeURIComponent(request.term),
                            success: function (data) {
                              console.log(data)
                                response($.map(data.hits, function (item) {
                                    return {
                                      label: decodeHtml(item.Title),
                                      value: decodeHtml(item.Title),
                                      description: item.Description,
                                      url: item.Url,
                                      isFundPage: item.IsFundPage,
                                      isGroupTitle: item.IsGroupTitle,
                                      isAllResults: item.IsAllResults
                                  };
                                }));
                            }
                        }, 300);
                },
                minLength: searchInputAutoCompMinLen,
                delay: 300,
                select: (e, t) => {
                    if (t.item.isAllResults) {
                        e.preventDefault();
                        location.href = t.item.url;
                    }
                },
            });

            if (autoComplete.length) autoComplete.autocomplete("instance")._renderItem = function (ul, item) {
            return $(`${item.url ? `<a href="${item.url}">` : ''}<li class='dropdown-item dropdown__item text-util-sm ${item.isGroupTitle && item.isGroupTitle === true ? 'group-title': ''} ${item.isFundPage && item.isFundPage === true ? 'fund-page': ''}'><strong>${item.label}</strong><br />${item.description}</li>${item.url ? '</a>' : ''}`)
                .on('click', function(e) {
                    if (item.isGroupTitle === true) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                })
                .appendTo(ul);
        };

    });

    $('#site-header-search').on('shown.bs.modal', function (e) {
        $('input.search__input').focus();
    });

    //$(".search__input").attr("list", "search-input-suggests");

    //$(".search__container").append("<div class='search-auto-comp'><ul class='auto-comp-list'></ul></div>");
}

searchScripts();